import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterASquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLetterASquare"><Path d="M12.0586 9.63574L12.9492 12.8232H11.0566L11.9473 9.63574H12.0586Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.6875 7.77246L7.8457 16.2275H10.1016L10.623 14.3701H13.3828L13.9043 16.2275H16.1602L13.3184 7.77246H10.6875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterASquare;
